import { render } from "./Ir.vue?vue&type=template&id=77835831&scoped=true"
import script from "./Ir.vue?vue&type=script&lang=js"
export * from "./Ir.vue?vue&type=script&lang=js"

import "./Ir.vue?vue&type=style&index=0&id=77835831&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77835831"]])

export default __exports__